export default function Matplotlib_Plotting() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MatplotlibPlotting Component</h1>
      <p>This is the MatplotlibPlotting component.</p>
    </div>
  );
}
